export default __webpack_public_path__ + "static/media/live-view-open-feed.3298e60f.svg";